(ns frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.view
  (:require
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.tabular-card :as tabular-card]
   [frontend.ui.component.lp-portal.report.module.free-text-card :as free-text-card]))

(defn- overview-card
  [{:keys [case-overview-text
           value-creation-plan-text
           latest-development-text
           overview-figures]}
   props]
  [card {}
   [:<>
    [free-text-card/free-text-section "Case Overview" case-overview-text props]
    #_[free-text-card/free-text-section "Value Creation Plan & Exit Vision" value-creation-plan-text
       props]
    [free-text-card/free-text-section "Latest Development" latest-development-text props]]
   [tabular-card/raw-stacked-table overview-figures props]])

(defn credit-company
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name
                reference-date
                report-id
                overview
                optional-section]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [section
      holding-name
      nil
      [:div
       [:div {}
        [overview-card overview props]]
       [:div {}
        [free-text-card/optional-text-card optional-section props]]]]]))
